import { Chip, Grid, Typography } from '@mui/material'
import { FaSyringe } from 'react-icons/fa'

export const EventRender = ({ event }) => {
  const aplicacoes = event.data?.[11]
  const qtAplicacoes = Number(aplicacoes?.qtAplicacoes || 0)
  const qtAplicados = Number(aplicacoes?.qtAplicados || 0)
  const possuiAplicacoes = qtAplicacoes > 0
  const aplicacoesFinalizadas = possuiAplicacoes && qtAplicacoes === qtAplicados

  return (
    <Grid
      container
      sx={{
        backgroundColor: event.data?.[9] ?? '#add8f7',
        height: '100%',
        borderRadius: 1,
        boxShadow: 1,
        mt: '-5px',
        p: 1.2,
        pb: possuiAplicacoes ? 4 : 1.2,
        position: 'relative',
      }}
    >
      <Grid item xs={12}>
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 400,
            fontSize: '1rem',
            color: event.data?.[10] ?? '#000',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {event.data?.[5]}
        </Typography>
      </Grid>
      {possuiAplicacoes && (
        <Chip
          icon={<FaSyringe size={12} />}
          label={aplicacoesFinalizadas ? 'Aplicada' : 'Aguardando'}
          size="small"
          sx={{
            bgcolor: aplicacoesFinalizadas ? '#2e7d32' : '#ed6c02',
            bottom: 6,
            color: '#fff',
            fontSize: '0.68rem',
            fontWeight: 600,
            height: 22,
            position: 'absolute',
            right: 6,
            '& .MuiChip-icon': {
              color: '#fff',
              ml: 0.7,
            },
            '& .MuiChip-label': {
              px: 1,
            },
          }}
        />
      )}
    </Grid>
  )
}
